import { useTroubleshootingStore } from "../troubleshootingStore/troubleshootingStore";
import { useScopedSites, useScopedTunnels } from "./useScope";

/**
 * Which kinds of link the chosen group or site actually has, so the Diagnosis
 * tab only waits on, counts, and mentions the checks that apply to it: a
 * WireGuard tunnel, an SMTP site, a Site-to-Site or direct path.
 *
 * For one site its own detail is authoritative (`wireguard`, integration).
 * `null` means "not known yet" — the detail or the list that says is still
 * loading — which the tab treats as still diagnosing, never as "none".
 */
export const useScopeKinds = () => {
  const {
    scope,
    siteId,
    siteDetail,
    siteDetailLoading,
    smtpSiteIds,
    siteToSite,
    tunnelsLoading,
    tunnelsError,
  } = useTroubleshootingStore();
  const scopedSites = useScopedSites();
  const scopedTunnels = useScopedTunnels();
  const scopedIds = new Set(scopedSites.map((site) => site.id));

  if (scope === "site") {
    const detailReady =
      siteId != null && !siteDetailLoading && siteDetail?.id === siteId;
    const integration = (siteDetail?.integration_type_name || "").toLowerCase();
    return {
      wireguard: detailReady ? siteDetail?.wireguard != null : null,
      smtp: detailReady
        ? integration.includes("smtp") || smtpSiteIds.includes(siteId as number)
        : null,
      paths:
        siteToSite?.status === "ok"
          ? siteToSite.data.some(
              (path) =>
                path.kind !== "wireguard" &&
                path.site_ids.includes(siteId as number)
            )
          : siteToSite == null
          ? null
          : false,
    };
  }
  return {
    // A failed tunnel list says nothing about whether the group has one.
    wireguard: tunnelsLoading || tunnelsError ? null : scopedTunnels.length > 0,
    smtp: scopedSites.some((site) => smtpSiteIds.includes(site.id)),
    paths:
      siteToSite?.status === "ok"
        ? siteToSite.data.some(
            (path) =>
              path.kind !== "wireguard" &&
              (scope === "all" || path.site_ids.some((id) => scopedIds.has(id)))
          )
        : siteToSite == null
        ? null
        : false,
  };
};
